const doc = [({"en":({"inside":"Interior", "outside":"Ocean View", "balcony":"Balcony", "suite":"Suite"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;